import React, { useCallback, useContext, useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DynamicTable from "../../../components/tables/dynamic-table1";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { DataContext } from "../../../components/layouts/main-layout";
import { useHotkeys } from "../../../components/helper-components/use-hotkeys";
import moment from "moment";
import {
  stockAuditTableAction,
  stockAuditDeleteAction,
} from "../../../redux/actions/stock-details-audit-action";
import AvgSaleIcon from "../../../assets/icons/billing-container-icons/avg-sales-icon";
import ReturnIcon from "../../../assets/icons/billing-container-icons/return-icon";
import TimerIconBg from "../../../assets/icons/billing-container-icons/timer-icon";
import RupeesIcon from "../../../assets/icons/billing-container-icons/rupee-icon";
import TransSummaryComp from "../../../components/helper-components/trans-summary-comp";
import StockAuditFilter from "../../../components/inventory/stock-audit/stock-audit-filter";
import BadgesComponent from "../../../components/tables/badges-component";
import DynamicTransactionTable from "../../../components/tables/dynamic-transaction-table";

const StockAuditTable = () => {
  const { permissionFn } = useContext(DataContext);
  const [billSummary, setBillSummary] = useState({});
  const [heading, setHeading] = useState([]);
  const dispatch = useDispatch();
  const [customers, setCustomers] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    selectColumn: "audit_number",
    from: "",
    to: "",
    inputValue: "",
    status: "",
    audit_type: "",
  });

  useEffect(() => {
    dispatch(
      stockAuditTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const auditList = parsed.find((obj) => obj?.stock_audit_list);
      if (auditList?.stock_audit_list) {
        setHeading(auditList.stock_audit_list);
      }
    }
  }, [currentPage, pageSize, filterData, reload]);
  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setCustomers(data?.data?.audits);
    setDataCount(data?.data?.totalCount);
    setBillSummary({
      pending_audits: data?.data?.pending_audits,
      completed_audits: data?.data?.completed_audits,
      completed_audits: data?.data?.completed_audits,
      avg_time_per_audit: data?.data?.avg_time_per_audit,
    });
  };
  const onError = (data) => {
    setError(true);
    setLoading(false);
  };

  const navigate = useNavigate();

  const tableBodyData = customers?.map((item) => {
    return {
      id: item?.sat_id,
      audit_number: item?.audit_number ?? "--",
      start_date: item?.start_date ?? "--",
      created_on: item?.created_on ? item?.created_on : "--",
      updated_on: item?.updated_on ? item?.updated_on : "--",
      discrepancy: item?.discrepancy ? item?.discrepancy : "--",
      audit_type: item?.audit_type ? item?.audit_type : "--",
      duration: item?.duration ? item?.duration : "--",
      created_by_name: item?.created_by_name || "",
      status:
        (
          <BadgesComponent
            status={item?.status === "cancel" ? "cancelled" : item?.status}
          />
        ) || "",
      sat_order_status: item?.status,
      total_items_count: item?.total_items_count || "",
      editable: ["draft", "open"].includes(item?.status),
      kibabMenu: ["draft", "open"].includes(item?.status),
      created_date: item?.created_date
        ? moment(item?.created_date).format("DD MMM YYYY")
        : "--",
      update_date: item?.update_date
        ? moment(item?.update_date).format("DD MMM YYYY")
        : "--",
      created_user_name: item?.created_user_name ?? "--",
      updated_user_name: item?.updated_user_name ?? "--",
    };
  });
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };
  const handleFilterClick = useCallback(() => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
  }, []);

  const filterby = showFilter ? (
    <StockAuditFilter
      filterData={filterData}
      setFilterData={setFilterData}
      setShowFilter={setShowFilter}
    />
  ) : null;

  useHotkeys("escape", () => {
    setShowFilter(false);
  });

  const TransactionSummary = [
    {
      conClass:
        "bg-[var(--trans-stats-con-orange-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Pending Audits",
      value: billSummary?.pending_audits,
      // desc: `₹${billSummary?.total_sales_pending} pending`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-orange-fg)]",
      icon: <TimerIconBg />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Completed Audits",
      value: billSummary?.completed_audits,
      // desc: `+${billSummary?.avg_sale_change_percentage}% vs yesterday`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-green-fg)]",
      icon: <RupeesIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },

    {
      conClass:
        "bg-[var(--trans-stats-con-red-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "High Discrepancies",
      value: billSummary?.return_count || 0,
      // desc: `₹${billSummary?.total_refunded} refunded`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-red-fg)]",
      icon: <ReturnIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Avg. Time per Audit",
      value: billSummary?.avg_time_per_audit,
      // desc: `+${billSummary?.today_avg_sale}% vs yesterday`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-blue-fg)]",
      icon: <AvgSaleIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
  ];

  const summaryArray =
    TransactionSummary?.length > 0 ? (
      <div className="px-[24px] pt-[16px] flex gap-5">
        {TransactionSummary?.map((sum) => (
          <TransSummaryComp sum={sum} />
        ))}
      </div>
    ) : (
      <></>
    );

  return (
    <InnerLayout
      list={true}
      title="Stock Audit"
      module="stock_audit"
      permissionFn={permissionFn}
    >
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <>
          <DynamicTransactionTable
            transaction="Audit"
            transaction_type="Audit"
            transactionKey="sat"
            id_name="sat_id"
            is_checkbox_req={false}
            onClickItemFn={(id) => navigate(`/view-audit/${id}`)}
            list={true}
            onclkFn={() => {
              navigate("/add-audit");
            }}
            cloneFn={(id) => {
              navigate(`/add-audit?cloneId=${id}`);
            }}
            permissionFn={permissionFn}
            module={"stock_audit"}
            path="audit"
            reload={reload}
            setReload={setReload}
            loading={loading}
            setLoading={setLoading}
            deleteAction={stockAuditDeleteAction}
            label="Audit"
            showFilter={showFilter}
            filterFn={handleFilterClick}
            setFilterData={setFilterData}
            filterData={filterData}
            paginationProps={paginationProps}
            tableHeading={heading}
            tableBodyData={tableBodyData}
            placeholder="Search (/)"
            filterBy={filterby}
            initialFilter={{
              sort_by: "",
              sort_order: "",
              selectColumn: "audit_number",
              from: "",
              to: "",
              inputValue: "",
              status: "",
              audit_type: "",
            }}
            summaryArray={summaryArray}
            actionsPermissions={{
              edit: ["draft"], // Edit allowed for "draft" and "open"
              delete: ["open"], // Void allowed only for "open"
              clone: ["open"]
              // closed & cancel -> no kebab menu actions
            }}
          />
        </>
      )}
    </InnerLayout>
  );
};

export default StockAuditTable;
